import axios from "axios"; // Import Axios for making HTTP requests

// Create an Axios instance with a base URL from environment variables
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Function to load opinions with pagination and optional filtering
export const loadOpinions = async (page = 1, filter = "") => {
  try {
    // Make a GET request to the /api/opinions endpoint with query parameters
    const response = await api.get("/opinions", {
      params: { services: filter || undefined, page, limit: 5 },
    });
    // Return the opinions and total pages from the response data
    return {
      opinions: response.data.opinions,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    // Log and rethrow the error if the request fails
    console.error("Error loading opinions:", error);
    throw error;
  }
};

// Function to submit a new opinion
export const submitOpinion = async (name, services, comment) => {
  try {
    // Make a POST request to the /api/opinions endpoint with the opinion data
    const response = await api.post("/opinions", {
      name,
      services,
      comment,
    });
    // Return the response data
    return response.data;
  } catch (error) {
    // Log and rethrow the error if the request fails
    console.error("Error submitting opinion:", error);
    throw error;
  }
};
